import { gql } from '@apollo/client'

export const SaveProjectGroupMutation = gql`
    mutation createProjectGroup($projectGroupInput: ProjectGroupInput!) {
        createProjectGroup(input: $projectGroupInput) {
            firmId
            name
        }
    }
`
export const UpdateProjectGroupMutation = gql`
    mutation updateProjectGroup($projectGroupInput: ProjectGroupInput!) {
        updateProjectGroup(input: $projectGroupInput) {
            id
            firmId
            name
        }
    }
`

export const RemoveProjectGroupWithProjectsMutation = gql`
    mutation removeProjectGroupWithProjects(
        $removeProjectGroupInput: RemoveProjectGroupInput!
    ) {
        removeProjectGroupWithProjects(input: $removeProjectGroupInput)
    }
`

export const RemoveProjectGroupAndMoveChildrenMutation = gql`
    mutation removeProjectGroupAndMoveChildrenInput(
        $removeProjectGroupInput: RemoveProjectGroupAndMoveChildrenInput!
    ) {
        removeProjectGroupAndMoveChildren(input: $removeProjectGroupInput)
    }
`
